<template>
  <NuxtLayout>
    <TrackingProvider />
    <NuxtPage />
  </NuxtLayout>
</template>
